import type { Reducer } from 'redux';

import type { PushNotificationsSaveSettingsAction } from '../../domains/pushNotifications/actions.types';

import type { PushNotificationsSettings } from './types';

export type PushNotificationsSettingsAction = PushNotificationsSaveSettingsAction;

export const initialState: PushNotificationsSettings = {
  clientId: crypto.randomUUID(),
  enabled: false,
};

const reducer: Reducer<PushNotificationsSettings, PushNotificationsSettingsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'PUSH_NOTIFICATIONS.SAVE_SETTINGS':
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default reducer;
